/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Retail_MultiplierInputs */

const en_setup_retail_multiplier = /** @type {(inputs: Setup_Retail_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retail multiplier`)
};

/**
* | output |
* | --- |
* | "Retail multiplier" |
*
* @param {Setup_Retail_MultiplierInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_retail_multiplier = /** @type {((inputs?: Setup_Retail_MultiplierInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Retail_MultiplierInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_retail_multiplier(inputs)
});